var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":"Cuenta bancaria","items":_vm.cuentasBancarias,"item-text":"descripcion","return-object":"","clearable":_vm.clearable},on:{"change":_vm.change},model:{value:(_vm.cuentaBancaria),callback:function ($$v) {_vm.cuentaBancaria=$$v},expression:"cuentaBancaria"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }